import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Urbaniaforpunetonashikonrent() {



    const cardData =
    {
        keyword: 'Urbania for Pune to Nashik On Rent',
        heading: 'Urbania on rent in pune: Urbania for Pune to Nashik On Rent',
        headingDescription: 'Urbania On Rent in Pune provides reliable and comfortable Urbania for Pune to Nashik On Rent services for families, corporate groups, tourists, and event travelers planning trips to Nashik. Our well-maintained Force Urbania fleet offers spacious seating, air-conditioned comfort, and smooth performance, making it ideal for weekend getaways, corporate tours, pilgrimages, sightseeing, and group travel from Pune to Nashik. With professional chauffeurs, flexible one-way and round-trip rental options, and convenient doorstep pickup from major areas including Hinjewadi, Baner, Wakad, Kharadi, Hadapsar, Kothrud, Pimpri Chinchwad, and Pune Airport, we ensure a safe, punctual, and stress-free journey. Backed by 24/7 booking support, transparent pricing, and trusted service, Urbania On Rent in Pune stands out as the preferred choice for Urbania hire from Pune to Nashik.',

        top: 'Top Places to Visit in Nashik with Urbania on rent in pune',


      "topPlaces": [
  {
    "title": "Trimbakeshwar Temple",
    "description": "Trimbakeshwar Temple, one of the twelve Jyotirlinga shrines of India, is located about 28 km from Nashik. Dedicated to Lord Shiva, the temple features a unique architecture with three faces of Shiva on the lingam. Pilgrims visit to perform rituals, take a holy dip in the Godavari River, and experience spiritual serenity amidst the surrounding Sahyadri hills."
  },
  {
    "title": "Sula Vineyards",
    "description": "Sula Vineyards is India’s most famous wine destination, attracting tourists for vineyard tours, wine tasting, and gourmet dining experiences. Visitors can explore sprawling vineyards, learn about wine-making processes, and enjoy scenic landscapes, making it a must-visit for leisure travelers and wine enthusiasts."
  },
  {
    "title": "Pandav Leni Caves",
    "description": "Pandav Leni are ancient rock-cut Buddhist caves dating back to 1st century BC. The caves feature intricate carvings, stupas, and chaityas, reflecting early Indian art and architecture. Surrounded by scenic hills, it is a popular spot for history enthusiasts, photographers, and spiritual seekers."
  },
  {
    "title": "Kalaram Temple",
    "description": "Kalaram Temple is a historic shrine dedicated to Lord Rama, constructed in black stone. Known for its spiritual atmosphere and annual festivals, the temple attracts thousands of devotees. The temple complex also has a beautiful courtyard and intricate architectural details that reflect traditional Maratha design."
  },
  {
    "title": "Anjneri Hills",
    "description": "Anjneri Hills, believed to be the birthplace of Lord Hanuman, are ideal for trekking and adventure activities. Visitors enjoy panoramic views of Nashik city and the surrounding Sahyadri ranges. The hills also hold mythological significance, making it a blend of nature and spirituality."
  },
  {
    "title": "Saptashrungi Temple",
    "description": "Saptashrungi Temple, situated on a hill near Nashik, is dedicated to Goddess Saptashrungi and is a major pilgrimage site. Devotees climb steep steps to reach the shrine, enjoying panoramic views of the valleys and forests. The temple is especially vibrant during annual festivals, attracting thousands of pilgrims."
  },
  {
    "title": "Godavari River Ghats",
    "description": "The ghats along the Godavari River are spiritually significant and scenic. Visitors perform rituals, take holy dips, and enjoy peaceful walks along the riverbanks. The ghats are also a cultural hub during festivals and religious events, offering a glimpse into local traditions."
  },
  {
    "title": "Coin Museum, Nashik",
    "description": "The Coin Museum houses an extensive collection of coins from ancient, medieval, and modern India. It is an educational and fascinating spot for history enthusiasts, offering insights into India’s numismatic heritage and economic history."
  },
  {
    "title": "Saptashrungi Hills Trek",
    "description": "Apart from the temple visit, the surrounding Saptashrungi hills offer trekking trails, scenic viewpoints, and nature walks. Adventure enthusiasts and nature lovers can enjoy the lush greenery, waterfalls, and panoramic vistas of the Sahyadri ranges."
  },
  {
    "title": "Sula Festival Grounds",
    "description": "Sula Festival Grounds, located near Sula Vineyards, host wine festivals, cultural events, and music concerts. Tourists visiting Nashik can combine leisure, entertainment, and wine tasting, making it a lively and memorable experience."
  }
],



"services": [
    {
      "name": "Urbania for Pune to Nashik on Rent",
      "description": "Urbania for Pune to Nashik on Rent provides comfortable, reliable, and well-maintained vehicles for travelers heading from Pune to Nashik. Perfect for families, friends, and small groups, the service ensures spacious seating, ample luggage space, and professional chauffeurs, delivering a safe and stress-free long-distance journey while maintaining punctuality and comfort."
    },
    {
      "name": "Pune to Nashik Urbania Hire",
      "description": "Pune to Nashik Urbania Hire offers convenient and cost-effective vehicle rentals for intercity travel. Ideal for group trips, corporate travel, and family outings, the service emphasizes safety, comfort, and timely arrivals, with trained drivers who are familiar with highway routes and provide smooth, hassle-free travel between Pune and Nashik."
    },
    {
      "name": "Urbania Bus Rental Pune to Nashik",
      "description": "Urbania Bus Rental Pune to Nashik provides spacious buses for group travel, school trips, corporate tours, and family outings. With ample seating, safety features, and professional chauffeurs, the service ensures a comfortable and convenient long-distance journey from Pune to Nashik, making it ideal for organized group travel."
    },
    {
      "name": "Urbania AC Bus Pune to Nashik",
      "description": "Urbania AC Bus Pune to Nashik offers fully air-conditioned buses for maximum comfort during intercity travel. Perfect for families, corporate groups, and long-distance travelers, these buses are equipped with climate control, spacious seating, experienced drivers, and safety features, ensuring a relaxing and enjoyable journey to Nashik."
    },
    {
      "name": "Pune Nashik Urbania One Way Hire",
      "description": "Pune Nashik Urbania One Way Hire provides flexible and convenient one-way travel for individuals, families, and corporate teams. Vehicles are well-maintained, spacious, and driven by professional chauffeurs, making it ideal for travelers who want a hassle-free journey from Pune to Nashik without worrying about return logistics."
    },
    {
      "name": "Pune Nashik Urbania Round Trip Hire",
      "description": "Pune Nashik Urbania Round Trip Hire offers reliable and comfortable round-trip travel solutions. With professional chauffeurs, punctual service, and clean, well-maintained vehicles, this service ensures that travelers can enjoy both their onward and return journey between Pune and Nashik smoothly and stress-free."
    },
    {
      "name": "Corporate Urbania Pune to Nashik",
      "description": "Corporate Urbania Pune to Nashik delivers professional transportation solutions for office trips, conferences, and corporate events. Vehicles are equipped for executive comfort with spacious seating, reliable chauffeurs, and timely service, providing a seamless and productive travel experience for corporate teams traveling between Pune and Nashik."
    },
    {
      "name": "Family Tour Urbania Pune to Nashik",
      "description": "Family Tour Urbania Pune to Nashik offers spacious, safe, and reliable vehicles for family trips and group outings. With courteous chauffeurs, ample luggage space, and comfortable interiors, travelers can enjoy a stress-free and enjoyable journey while focusing on their leisure and sightseeing plans in Nashik."
    },
    {
      "name": "Luxury Urbania Pune to Nashik",
      "description": "Luxury Urbania Pune to Nashik provides high-end air-conditioned vehicles with plush interiors, designed for VIPs, executives, and travelers seeking premium comfort. With professional chauffeurs, smooth rides, and attention to detail, this service ensures a luxurious travel experience for long-distance journeys between Pune and Nashik."
    },
    {
      "name": "Affordable Urbania Pune to Nashik",
      "description": "Affordable Urbania Pune to Nashik delivers cost-effective intercity transportation without compromising on comfort or reliability. Ideal for budget-conscious travelers, families, and small groups, this service focuses on clean vehicles, safe driving, punctual service, and courteous chauffeurs to provide value for money."
    },
    {
      "name": "Chauffeur Driven Urbania Pune to Nashik",
      "description": "Chauffeur Driven Urbania Pune to Nashik offers stress-free travel with experienced and verified drivers. Vehicles are reliable, spacious, and maintained for long-distance trips, ensuring that families, groups, and corporate travelers can enjoy a comfortable and safe journey without worrying about navigation or driving conditions."
    },
    {
      "name": "Pune Nashik Urbania Travel Service",
      "description": "Pune Nashik Urbania Travel Service provides end-to-end transportation solutions for trips between Pune and Nashik. From well-maintained vehicles and trained chauffeurs to timely pickups and convenient luggage handling, this service ensures a seamless, comfortable, and enjoyable travel experience for all types of travelers."
    },
    {
      "name": "Best Urbania Hire Pune to Nashik",
      "description": "Best Urbania Hire Pune to Nashik delivers top-rated intercity travel services with a focus on reliability, vehicle quality, and customer satisfaction. Ideal for families, corporate teams, and groups, the service ensures comfortable, safe, and punctual journeys from Pune to Nashik."
    },
    {
      "name": "Pune to Nashik Urbania Booking",
      "description": "Pune to Nashik Urbania Booking enables easy and convenient reservation of Urbania vehicles for one-way or round-trip travel. Travelers can choose from a variety of vehicle options, ensuring comfort, safety, and professional chauffeur services for a hassle-free journey between Pune and Nashik."
    },
    {
      "name": "Urbania for Outstation Trip Pune to Nashik",
      "description": "Urbania for Outstation Trip Pune to Nashik provides reliable vehicles and professional chauffeur services for long-distance travel. Perfect for family outings, group tours, and corporate trips, the service emphasizes safety, punctuality, comfort, and a seamless experience on the Pune–Nashik route."
    }
  ],
  "tableData": [
    ["Urbania for Pune to Nashik on Rent", "Pune to Nashik Urbania Hire"],
    ["Urbania Bus Rental Pune to Nashik", "Urbania AC Bus Pune to Nashik"],
    ["Pune Nashik Urbania One Way Hire", "Pune Nashik Urbania Round Trip Hire"],
    ["Corporate Urbania Pune to Nashik", "Family Tour Urbania Pune to Nashik"],
    ["Luxury Urbania Pune to Nashik", "Affordable Urbania Pune to Nashik"],
    ["Chauffeur Driven Urbania Pune to Nashik", "Pune Nashik Urbania Travel Service"],
    ["Best Urbania Hire Pune to Nashik", "Pune to Nashik Urbania Booking"],
    ["Urbania for Outstation Trip Pune to Nashik", ""]
  ],





"whychoose": [
    {
        "WhyChooseheading": "Reliable Urbania for Pune to Nashik On Rent",
        "WhyChoosedescription": "Urbania for Pune to Nashik On Rent is perfect for comfortable and spacious group travel, suitable for family trips, corporate travel, weddings, and outstation journeys."
    },
    {
        "WhyChooseheading": "Spacious and Comfortable Force Urbania Vehicles",
        "WhyChoosedescription": "Urbania for Pune to Nashik On Rent provides well-maintained Force Urbania vehicles with ample seating and luggage space, ensuring a smooth and hassle-free ride."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Urbania for Pune to Nashik On Rent comes with skilled drivers familiar with Pune-Nashik routes and highways, ensuring safe, timely, and stress-free travel."
    },
    {
        "WhyChooseheading": "Transparent and Affordable Pricing",
        "WhyChoosedescription": "Choose Urbania for Pune to Nashik On Rent for competitive rates with no hidden charges, making outstation group travel budget-friendly and reliable."
    },
    {
        "WhyChooseheading": "24/7 Booking and Customer Support",
        "WhyChoosedescription": "Urbania for Pune to Nashik On Rent provides round-the-clock assistance for bookings, inquiries, and last-minute travel requirements."
    },
    {
        "WhyChooseheading": "Flexible Rental Packages",
        "WhyChoosedescription": "Urbania for Pune to Nashik On Rent is available for one-way trips, round trips, corporate travel, wedding transportation, and customized packages."
    },
    {
        "WhyChooseheading": "Clean, Sanitized, and Well-Maintained Vehicles",
        "WhyChoosedescription": "All Urbania vehicles for Pune to Nashik trips are regularly cleaned, sanitized, and serviced to ensure a safe and comfortable journey."
    },
    {
        "WhyChooseheading": "Punctual and Reliable Service",
        "WhyChoosedescription": "Urbania for Pune to Nashik On Rent guarantees timely pickups and dependable service, ensuring stress-free and smooth travel."
    }
]
}

const faqData = [
    {
        question: 'Is Urbania for Pune to Nashik On Rent available for local travel as well?',
        answer: 'Yes, Urbania for Pune to Nashik On Rent can also be booked for local travel within Pune or nearby areas, offering a comfortable and spacious ride.',
    },
    {
        question: 'How can I book Urbania for Pune to Nashik On Rent?',
        answer: 'You can book Urbania for Pune to Nashik On Rent via phone, WhatsApp, or online for quick and hassle-free reservations.',
    },
    {
        question: 'Why choose Urbania for Pune to Nashik On Rent for group travel?',
        answer: 'Urbania for Pune to Nashik On Rent provides ample seating, luggage space, and a smooth ride, making it ideal for family, corporate, and group travel.',
    },
    {
        question: 'Is Urbania for Pune to Nashik On Rent suitable for corporate and event travel?',
        answer: 'Yes, it is perfect for corporate trips, airport transfers, weddings, events, and one-way or round-trip travel to Nashik.',
    },
    {
        question: 'Are drivers experienced with Urbania for Pune to Nashik On Rent?',
        answer: 'Yes, all drivers are professionally trained, licensed, and experienced in handling Force Urbania vehicles to ensure safe and comfortable travel.',
    },
    {
        question: 'Can I customize pickup and drop-off locations with Urbania for Pune to Nashik On Rent?',
        answer: 'Absolutely. Urbania for Pune to Nashik On Rent allows flexible pickup and drop-off across Pune and Nashik.',
    },
    {
        question: 'Is Urbania for Pune to Nashik On Rent available 24x7?',
        answer: 'Yes, Urbania for Pune to Nashik On Rent operates 24x7 to accommodate travel needs at any time.',
    },
    {
        question: 'Are hygiene and safety standards maintained for Urbania for Pune to Nashik On Rent?',
        answer: 'Yes, all vehicles are regularly cleaned, sanitized, and maintained with strict safety protocols for every trip.',
    },
    {
        question: 'What payment options are available for Urbania for Pune to Nashik On Rent?',
        answer: 'Urbania for Pune to Nashik On Rent accepts UPI, digital wallets, credit/debit cards, bank transfers, and corporate billing options.',
    },
    {
        question: 'Is customer support available during the journey?',
        answer: 'Yes, dedicated customer support is available throughout the journey to ensure a smooth and stress-free experience.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Sandeep Kulkarni',
        feedback: 'We booked Urbania for Pune to Nashik On Rent for a family trip. The vehicle was spacious, comfortable, and reliable. Excellent service!',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Meera Patil',
        feedback: 'Urbania for Pune to Nashik On Rent provided seamless service for our corporate outstation travel. The driver was professional and punctual. Highly recommended!',
        rating: 5,
    },
];


























































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Urbania On Rent Pune", link: "urbania-on-rent-pune" },
        { place: "/images/keyword/2.jpg", text: "Urbania on Rent in Pimpri Chinchwad", link: "urbania-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/3.jpg", text: "Urbania Hire for Corporate Events in Pune", link: "urbania-hire-for-corporate-events-in-pune" },
        { place: "/images/keyword/4.jpg", text: "17 Seater Urbania on Rent in Pune", link: "17-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/5.jpg", text: "14 Seater Urbania on Rent in Pune", link: "14-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/6.jpg", text: "Urbania on Rent in Kharadi", link: "urbania-on-rent-in-kharadi" },
        { place: "/images/keyword/7.jpg", text: "Urbania on Rent in Hadapsar", link: "urbania-on-rent-in-hadapsar" },
        { place: "/images/keyword/8.jpg", text: "Urbania on Rent in Kothrud", link: "urbania-on-rent-in-kothrud" },
        { place: "/images/keyword/9.jpg", text: "Urbania On Rent in Bibwewadi", link: "urbania-on-rent-in-bibwewadi" },
        { place: "/images/keyword/10.jpg", text: "Urbania on Rent in Koregaon Park", link: "urbania-on-rent-in-koregaon-park" },
        { place: "/images/keyword/11.jpg", text: "Urbania On Rent in Kalyani Nagar", link: "urbania-on-rent-in-kalyani-nagar" },
        { place: "/images/keyword/12.jpg", text: "Urbania On Rent in Mundhwa Pune", link: "urbania-on-rent-in-mundhwa-pune" },
        { place: "/images/keyword/13.jpg", text: "Urbania Bus On Rent in Baner", link: "urbania-bus-on-rent-in-baner" },
        { place: "/images/keyword/14.jpg", text: "Urbania AC Bus On Rent in Aundh", link: "urbania-ac-bus-on-rent-in-aundh" },
        { place: "/images/keyword/15.jpg", text: "Urbania Bus On Rent in Hinjewadi", link: "urbania-bus-on-rent-in-hinjewadi" },
        { place: "/images/keyword/16.jpg", text: "Urbania on Rent in Bhosari", link: "urbania-on-rent-in-bhosari" },
        { place: "/images/keyword/17.jpg", text: "Urbania on Rent in Pune Station", link: "urbania-on-rent-in-pune-station" },
        { place: "/images/keyword/18.jpg", text: "Urbania On Rent in Chakan", link: "urbania-on-rent-in-chakan" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Moshi", link: "urbania-on-rent-in-moshi" },
        { place: "/images/keyword/20.jpg", text: "Urbania On Rent in Charholi Budruk", link: "urbania-on-rent-in-charholi-budruk" },
        { place: "/images/keyword/21.jpg", text: "Urbania On Rent in Nigdi Pradhikaran", link: "urbania-on-rent-in-nigdi-pradhikaran" },
        { place: "/images/keyword/22.jpg", text: "Urbania On Rent in Lohegaon", link: "urbania-on-rent-in-lohegaon" },
        { place: "/images/keyword/23.jpg", text: "Urbania On Rent in Wagholi", link: "urbania-on-rent-in-wagholi" },
        { place: "/images/keyword/24.jpg", text: "Urbania Rental Service in Pune", link: "urbania-rental-service-in-pune" },
        { place: "/images/keyword/25.jpg", text: "Best Urbania on Rent in Pune", link: "best-urbania-on-rent-in-pune" }
    ];













const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Urbania for Pune to Nashik On Rent",
  "image": "https://urbaniaonrentpune.in/assets/images/urbania-pune-to-nashik.jpg",
  "description": "Urbania for Pune to Nashik On Rent provides reliable AC and non-AC bus rental services for one-way and round-trip travel. Perfect for family tours, corporate trips, luxury travel, and outstation journeys. Chauffeur-driven Urbania buses ensure comfortable, safe, and affordable travel from Pune to Nashik.",
  "brand": {
    "@type": "Brand",
    "name": "Urbania on Rent in Pune"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "1020",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "5200",
    "availability": "https://schema.org/InStock",
    "url": "https://urbaniaonrentpune.in/urbania-pune-to-nashik-on-rent"
  }
};





    return (
        <div>

<Helmet>
  <title>
    Call:+91 9209423113 | Urbania for Pune to Nashik On Rent | AC & Luxury Urbania Bus Hire 
  </title>

  <meta
    name="description"
    content="Book Urbania for Pune to Nashik On Rent for one-way or round-trip travel. AC and non-AC Urbania buses for family tours, corporate trips, luxury travel, and outstation journeys. Chauffeur-driven service for safe and comfortable trips."
  />

  <meta
    name="keywords"
    content="Urbania for Pune to Nashik on Rent, Pune to Nashik Urbania Hire, Urbania Bus Rental Pune to Nashik, Urbania AC Bus Pune to Nashik, Pune Nashik Urbania One Way Hire, Pune Nashik Urbania Round Trip Hire, Corporate Urbania Pune to Nashik, Family Tour Urbania Pune to Nashik, Luxury Urbania Pune to Nashik, Affordable Urbania Pune to Nashik, Chauffeur Driven Urbania Pune to Nashik, Pune Nashik Urbania Travel Service, Best Urbania Hire Pune to Nashik, Pune to Nashik Urbania Booking, Urbania for Outstation Trip Pune to Nashik"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <div
                className="breadcumb-wrapper"
                
                data-overlay="black"
                data-opacity="3"
            >
                <div className="container">
                    <div className="breadcumb-content text-center">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/32.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>



                            <div className="shambhu-services">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="sh-service-card">

                                        <div className="sh-service-left">
                                            <div className="sh-service-icon">
                                                🚌
                                            </div>
                                        </div>

                                        <div className="sh-service-content">
                                            <h4 className="sh-service-title">{service.name}</h4>
                                            <p className="sh-service-desc">{service.description}</p>
                                        </div>

                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Urbania On rent in Pune </span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Urbania on rent in Pune </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919209423113" className="pc-call">+91 9209423113</a>
                                            <a href="tel:+917620411277 " className="pc-call">+91 7620411277 </a>
                                            <a href="tel:+919284718314" className="pc-call">+91 9284718314</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919209423113"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919209423113" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@urbaniaonrentpune.in" className="pc-email">
                                            booking@urbaniaonrentpune.in
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Urbania on rent in pune</strong><br />
                                            Saket Tata Power CHS, Swami Samarth Marg,
                                            Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                                            Maharashtra India - 400703
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Urbaniaforpunetonashikonrent;